export default "__VITE_ASSET__B6wVS58Q__"